import uuid from 'react-uuid';

import { ApolloLink } from '@apollo/client';

import { getAppVersion, getToken, setOperationUuid } from '@utils/localStorage';
import { getSessionKey } from '@utils/session';
import { getDeviceKey } from '@utils/device';

const RefreshMiddleware = new ApolloLink((operation, forward) => {
  const apolloToken = getToken();
  const sessionUuid = getSessionKey();
  const operationUuid = uuid();
  setOperationUuid(operationUuid);
  const device = getDeviceKey();
  const appVersion = getAppVersion();
  const parsedVersion = appVersion ? appVersion.replaceAll('"', '') : appVersion;
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      authorization: apolloToken || null,
      'X-Device': device,
      'X-App': 'WEB',
      'X-Version': parsedVersion,
      'X-Correlation-ID': operationUuid,
      'X-Session-ID': sessionUuid,
    },
  }));

  return forward(operation);
});

export default RefreshMiddleware;
